export const jobs = [
  {
    title: "CMPC",
    time: "2022 - Actualidad",
    description: "Desarrollador ReactJs",
    details: "Parte del equipo de innovación, encargados de digitalizar procesos y crear una plataforma de clase y uso mundial en donde se pueda modernizar el contacto del cliente con la empresa.",
  },
  {
    title: "Mobdev",
    time: "2022",
    description: "Desarrollador ReactJs",
    details: "Como parte de una empresa externa, presté servicios para el banco Scotiabank de Chile, en una célula en donde mayormente me desempeñé en la resolución de problemas con las herramientas que ya estaban implementadas, o hacer cambios que no superen las 2 semanas",
  },
  {
    title: "Devaid",
    time: "2020 - 2022",
    description: "Desarrollador ReactJs",
    details: "Me he desempeñado como desarrollador ReactJs, en donde he hecho mantención en una aplicación de 'ticketera' ya creada, además, he creado una aplicación desde 0 de gestión de rutas.",
  },
  {
    title: "PiikApp",
    time: "2020",
    description: "Desarrollador ReactJs & Ruby on Rails",
    details: "Me desmpeñé como desarrollador de software en ReactJs y Ruby on Rails, en donde hice mantenciones a la API del negocio y página web del mismo, además de crear una plataforma de administración general del negocio.",
  },
  {
    title: "SCD",
    time: "2019 - 2020",
    description: "Desarrollador Angular 7+ & SpringBoot",
    details: "Primer trabajo como desarrollador de software, en donde participé en la creación de herramientas internas de la empresa.",
  },
  {
    title: "Everis Temuco",
    time: "2018 - 2019",
    description: "Desarrollador ETL",
    details: "Primer trabajo formal, en donde me desmpeñé como desarrollador en Bussiness Intelligence, creando ETL's en PowerCenter para el banco Santander de Murcia.",
  },
];
